import React, { Component } from 'react';
import {
  Box,
  CircularProgress,
  IconButton,
  Tooltip,
  Typography,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import GetAppIcon from '@material-ui/icons/GetApp';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import i18n from '../../i18n';

import '../../assets/stylesheets/CircularProgressButton.css';

class DownloadIconButton extends Component {
  render() {
    const {
      className,
      downloadLink,
      contentLength,
      filename,
      onClick,
      progress,
    } = this.props;

    if (progress) {
      return (
        progress !== 100 ? (
          <Box className='cpbContainer'>
            <Box className='cpbWrapper'>
              <CircularProgress 
                color='inherit'
                variant='determinate'
                value={progress}
                className={`cpbSpinner ${className}`}
              />
              <Box className='cpbProgressContainer'>
                <Typography variant="caption" component="div" color='inherit'>
                  {`${progress}%`}
                </Typography>
              </Box>
            </Box>
          </Box>
        )
        :
        (
          <CheckCircleIcon className='greenText' />
        )
      )
    }

    return (
      <Tooltip title={<Typography>{i18n.t('reporting:downloadFolder')}</Typography>}>
        <IconButton
          edge='end'
          aria-label='download'
          downloadlink={downloadLink}
          contentlength={contentLength}
          filename={filename}
          onClick={onClick}
        >
          <GetAppIcon className='blackText' />
        </IconButton>
      </Tooltip>
    );
  }
}

DownloadIconButton.defaultProps = {
  progress: null,
  className: '',
}

DownloadIconButton.propTypes = {
  className: PropTypes.string,
  downloadLink: PropTypes.string.isRequired,
  contentLength: PropTypes.number.isRequired,
  filename: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  progress: PropTypes.number,
}

export default DownloadIconButton;
